"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE_BUTTON = void 0;
const SUBSCRIBE_BUTTON = exports.SUBSCRIBE_BUTTON = 'subscribe-button';